export default __webpack_public_path__ + "static/media/Dropbox.40ab81a6.svg";